type ErrorProps = {
  text: string;
};

const Error = ({ text }: ErrorProps) => {
  return (
    <div
      style={{
        textAlign: 'left',
        margin: '1rem 0',
      }}
    >
      <span className={'text-danger'}>{text}</span>
    </div>
  );
};

export default Error;
